import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["src", "path", "extension"];
import { StringToRgba, RgbaToUrl, HexToRGBA } from '@swp/colors';
export default (function (src, color) {
  if (!src || typeof src !== 'string') {
    return undefined;
  }

  if (/\.svg$/.test(src) && color) {
    src = src.replace(process.env.CDN_HOST + 'o/', process.env.CDN_HOST + 't/');
    src = src.replace(/\.svg$/, "_col=" + RgbaToUrl(StringToRgba(color)) + "_.svg");
  }

  return src.replace(/%2C/g, 'x');
});
export function transform(_ref, width, height) {
  var src = _ref.src,
      path = _ref.path,
      extension = _ref.extension,
      options = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (!path && !extension && src) {
    var parts = src.split('.');
    extension = '.' + parts.pop();
    path = parts.join('.');
  }

  if (extension === '.svg') {
    return path + extension;
  }

  var transforms = "_s=" + width + "x" + (height || '');
  path = path.replace(process.env.CDN_HOST + 'o/', process.env.CDN_HOST + 't/');

  for (var key in options) {
    var value = options[key];

    if (value === null || value === undefined) {
      continue;
    }

    switch (key) {
      // case 'overlay':
      //   path += '_ove=' + value
      //   break
      case 'blur':
        path += '_bl=' + value;
        break;

      case 'saturate':
        path += '_sat=' + value;
        break;
    }
  }

  return path + transforms + '_' + extension;
}
export function getOverlay(color) {
  if (!color) return '';
  var hex = color.match(/[0-9a-f]{6}x\d+/i);

  if (hex) {
    var _color$split = color.split('x'),
        channels = _color$split[0],
        alpha = _color$split[1];

    color = HexToRGBA("#" + channels, alpha);
  }

  return "linear-gradient(" + color + ", " + color + "), ";
}
export function getBackgroundImage(image, size) {
  return "url(" + transform(image, size) + ")";
}